export default "__VITE_ASSET__BawAIs1J__"